<template>
    <v-dialog v-model="model" max-width="960" scrollable :fullscreen="isMobile" mobile-breakpoint="md">
        <v-theme-provider :theme="theme" with-background>
            <DialogLayout title="Terms of Service" body-class="pa-0" @close="close">
                <TermsOfService />
            </DialogLayout>
        </v-theme-provider>
    </v-dialog>
</template>

<script lang="ts" setup>
    import DialogLayout from '@/components/global/DialogLayout.vue';
    import TermsOfService from '@/components/global/TermsOfService.vue';
    import { computed } from 'vue';
    import { useDisplay } from 'vuetify';

    const props = defineProps<{
        modelValue: boolean;
        theme?: string;
    }>();

    const emit = defineEmits<{
        (e: 'update:modelValue', value: boolean): void;
    }>();

    const model = computed({
        get: () => props.modelValue,
        set: (value: boolean) => emit('update:modelValue', value),
    });

    const display = useDisplay();
    const isMobile = computed(() => display.mobile.value);
    const theme = computed(() => props.theme);

    const close = () => {
        model.value = false;
    };
</script>

<style lang="scss" scoped></style>
